import router from './routers'
import store from '@/store'
import Config from '@/settings'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getToken
} from '@/utils/auth' // getToken from cookie
import {
  getMenus
} from '@/api/system/menu'
import {
  filterAsyncRouter, filterRouter
} from '@/store/modules/permission'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration
import Cookies from 'js-cookie'
// let lang = Cookies.get('lang')
const whiteList = ['/login'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    // 已登录且要跳转的页面是登录页
    if (to.path === '/login') {
      next({
        path: '/'
      })
      NProgress.done()
    } else {
      if (store.getters.tokenstate === 1) { // 判断当前用户是否已拉取完user_info信息
        // console.log('store.getters.token.length', store.getters.tokenstate);
        store.dispatch('GetInfo').then(() => { // 拉取user_info
          // 动态路由，拉取菜单
          loadMenus(next, to)
        }).catch(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
        // 登录时未拉取 菜单，在此处拉取
      } else if (store.getters.loadMenus) {
        // 修改成false，防止死循环
        store.dispatch('updateLoadMenus')
        loadMenus(next, to)
      } else {
        next()
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

export const loadMenus = (next, to) => {
  getMenus().then(res => {
    var compare = function (obj1, obj2) {
      var val1 = obj1.sort
      var val2 = obj2.sort
      if (val1 < val2) {
        return -1;
      } else if (val1 > val2) {
        return 1;
      } else {
        return 0;
      }
    }
    // 菜单排序
    res.datas.sort(compare)
    res.datas.forEach(item => {
      if (item.children && item.children.length > 0) {
        item.children.sort(compare)
        item.children.forEach(item => {
          if (item.children && item.children.length > 0) {
            item.children.sort(compare)
          }
        })
      }
    })
    const sdata = JSON.parse(JSON.stringify(res.datas))
    const rdata = JSON.parse(JSON.stringify(res.datas))
    const sidebarRoutes = filterAsyncRouter(sdata)
    const rewriteRoutes = filterRouter(rdata, false, true)
    rewriteRoutes.push({
      path: '*',
      redirect: '/404',
      hidden: true
    })

    store.dispatch('GenerateRoutes', rewriteRoutes).then(() => {
      // 存储路由
      router.addRoutes(rewriteRoutes) // 动态添加可访问路由表
      next({
        ...to,
        replace: true
      })
    })
    store.dispatch('SetSidebarRouters', sidebarRoutes)
  })
}
router.afterEach((to, from) => {
  // console.log("afterEach:",to,from)
  let tag = {};
  tag.name = to.name;
  tag.query = to.query;
  tag.label = to.meta.title,
    sessionStorage.setItem("path", to.path);
  // store.commit('selectMenu', tag)
  NProgress.done() // finish progress bar
})